import { installErrorBuffer } from '@/lib/error-buffer'

window.global ||= window

// Capture unhandled errors from app bootstrap, so a feedback report filed
// later carries the stack that caused it.
//
// Not literally the first thing that runs: `@trivago/prettier-plugin-sort-imports`
// sorts main.tsx's imports alphabetically, so `@/app/app` is evaluated before
// `@/init` and reordering them is undone by the next `format:write`. The
// uncovered window is the app graph's own module evaluation, where a throw
// means a blank page rather than a report anyone could file.
installErrorBuffer()
